import { Helmet } from "react-helmet";

// ===== Font Awesome Icons =====
import {
  FaAndroid,
  FaApple,
  FaArrowRight,
  FaBrain,
  FaBullhorn,
  FaCheckCircle,
  FaCloud,
  FaCode,
  FaCodeBranch,
  FaCogs,
  FaDatabase,
  FaDocker,
  FaGlobe,
  FaJava,
  FaLayerGroup,
  FaMicrosoft,
  FaMobileAlt,
  FaNodeJs,
  FaPalette,
  FaPhp,
  FaPython,
  FaReact,
  FaRedo,
  FaSearch,
  FaShoppingCart,
  FaTools,
} from "react-icons/fa";

// ===== Simple Icons (Brand Icons) =====
import { SiFlutter } from "react-icons/si";

import "./ServicesTechnologies.css";

const ServicesTechnologies = () => {
  return (
    <>
      <Helmet>
        <title>Our Services & Technologies | Oglitz Software Pvt Ltd</title>
        <meta
          name="description"
          content="Oglitz Software provides premium custom software development, web & mobile apps, cloud solutions, UI/UX design, and modern technologies for global businesses."
        />
        <link
          rel="canonical"
          href="https://www.oglitz.com/services-technologies"
        />
      </Helmet>

      {/* ================= HERO ================= */}
      <section className="oglitz-hero">
        <div className="oglitz-hero-bg" />

        <div className="oglitz-hero-inner">
          <span className="oglitz-hero-badge">Enterprise Software Company</span>

          <h1 className="oglitz-hero-title">
            Premium Software Services
            <br />
            <span>Built for Scale & Performance</span>
          </h1>

          <p className="oglitz-hero-desc">
            Oglitz designs and engineers secure, scalable, and high-performance
            digital solutions for startups, enterprises, and global brands.
          </p>

          <div className="oglitz-hero-actions">
            <a href="/contact" className="oglitz-btn-primary">
              Start Your Project <FaArrowRight />
            </a>

            <a href="/projects" className="oglitz-btn-secondary">
              View Our Work
            </a>
          </div>
        </div>
      </section>

      <section className="srv-section">
        <h2 className="srv-section-title">Our Services</h2>

        <div className="srv-grid">
          <a href="/start-project" className="srv-card">
            <FaCode />
            <h3>Custom Software Development</h3>
            <p>Tailored enterprise-grade software solutions.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaMobileAlt />
            <h3>Web & Mobile Applications</h3>
            <p>High-performance cross-platform applications.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaCloud />
            <h3>Cloud Services</h3>
            <p>Scalable cloud architecture & consulting.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaPalette />
            <h3>Design & UI/UX</h3>
            <p>Modern, user-focused digital experiences.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaShoppingCart />
            <h3>E-Commerce Solutions</h3>
            <p>Secure and scalable online stores.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaCogs />
            <h3>API Development</h3>
            <p>Robust integrations and system APIs.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaSearch />
            <h3>Search Engine Optimization (SEO)</h3>
            <p>Improve visibility and organic growth.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaBullhorn />
            <h3>Digital Marketing</h3>
            <p>Performance-driven digital marketing solutions.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaAndroid />
            <h3>Android App Development</h3>
            <p>Custom Android applications.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaApple />
            <h3>iOS Applications</h3>
            <p>Premium iOS app development.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaReact />
            <h3>React JS Applications</h3>
            <p>Modern frontend applications with React.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaReact />
            <h3>React Native Applications</h3>
            <p>Cross-platform mobile apps.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaGlobe />
            <h3>Website Designing</h3>
            <p>Creative, responsive website designs.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaRedo />
            <h3>Website Redesigning</h3>
            <p>Revamp and modernize existing websites.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaTools />
            <h3>Application Maintenance</h3>
            <p>Ongoing support and system maintenance.</p>
          </a>

          <a href="/start-project" className="srv-card">
            <FaLayerGroup />
            <h3>CMS Applications</h3>
            <p>Flexible content management solutions.</p>
          </a>
        </div>
      </section>

      {/* ================= TECHNOLOGIES ================= */}
      <section className="oglitz-tech-section">
        <div className="oglitz-tech-wrapper">
          <h2 className="oglitz-tech-title">
            Technologies We Use
            <span className="oglitz-tech-divider" />
          </h2>

          <div className="oglitz-tech-grid">
            <div className="oglitz-tech-card cloud">
              <FaCloud />
              <span>Cloud Platforms (AWS, Azure, Google Cloud)</span>
            </div>

            <div className="oglitz-tech-card react">
              <FaReact />
              <span>React JS</span>
            </div>

            <div className="oglitz-tech-card react-native">
              <FaReact />
              <span>React Native</span>
            </div>

            <div className="oglitz-tech-card node">
              <FaNodeJs />
              <span>Node.js</span>
            </div>

            <div className="oglitz-tech-card python">
              <FaPython />
              <span>Python</span>
            </div>

            <div className="oglitz-tech-card graphql">
              <FaCodeBranch />
              <span>GraphQL</span>
            </div>

            <div className="oglitz-tech-card mongodb">
              <FaDatabase />
              <span>MongoDB</span>
            </div>

            <div className="oglitz-tech-card mysql">
              <FaDatabase />
              <span>MySQL</span>
            </div>

            <div className="oglitz-tech-card docker">
              <FaDocker />
              <span>Docker</span>
            </div>

            <div className="oglitz-tech-card microsoft">
              <FaMicrosoft />
              <span>Microsoft Technologies</span>
            </div>

            <div className="oglitz-tech-card android">
              <FaAndroid />
              <span>Android</span>
            </div>

            <div className="oglitz-tech-card apple">
              <FaApple />
              <span>iOS</span>
            </div>

            <div className="oglitz-tech-card php">
              <FaPhp />
              <span>PHP Core & Frameworks</span>
            </div>

            <div className="oglitz-tech-card java">
              <FaJava />
              <span>Java Platform</span>
            </div>

            <div className="oglitz-tech-card native">
              <FaMobileAlt />
              <span>Native App Development</span>
            </div>

            <div className="oglitz-tech-card ai">
              <FaBrain />
              <span>AI / Machine Learning</span>
            </div>

            <div className="oglitz-tech-card flutter">
              <SiFlutter />
              <span>Flutter</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHY TRUST OGLITZ ================= */}
      <section className="oglitz-trust-section">
        <div className="oglitz-trust-wrapper">
          <h2 className="oglitz-trust-title">
            Why Businesses Trust Oglitz
            <span className="oglitz-trust-divider" />
          </h2>

          <div className="oglitz-trust-grid">
            <div className="oglitz-trust-card">
              <span className="oglitz-trust-icon">
                <FaCheckCircle />
              </span>
              <h4>Enterprise Quality</h4>
              <p>
                Scalable architecture and clean, maintainable code built for
                growth.
              </p>
            </div>

            <div className="oglitz-trust-card">
              <span className="oglitz-trust-icon">
                <FaCheckCircle />
              </span>
              <h4>Modern Technology Stack</h4>
              <p>
                Future-ready solutions using the latest, proven technologies.
              </p>
            </div>

            <div className="oglitz-trust-card">
              <span className="oglitz-trust-icon">
                <FaCheckCircle />
              </span>
              <h4>Global Delivery Model</h4>
              <p>
                India & UAE presence enabling seamless worldwide client
                delivery.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="srv-global srv-global-light">
        <div className="srv-global-wrapper">
          <div className="srv-global-icon">
            🌍
            <span className="icon-glow" />
          </div>

          <h2 className="srv-global-title">
            Serving Clients Worldwide
            <span className="title-accent" />
          </h2>

          <p className="srv-global-desc">
            With dedicated development teams in India and strategic business
            operations in the UAE, <strong>Oglitz</strong> delivers secure,
            scalable, and transparent digital solutions to clients across the
            globe.
          </p>

          <div className="srv-global-stats">
            <div className="srv-stat-card">
              <strong>India</strong>
              <span>Development Hub</span>
            </div>

            <div className="srv-stat-card">
              <strong>UAE</strong>
              <span>Business Operations</span>
            </div>

            <div className="srv-stat-card">
              <strong>Global</strong>
              <span>Client Delivery</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="srv-cta srv-cta-dark">
        <div className="srv-cta-wrapper">
          <span className="srv-cta-eyebrow">Let’s Work Together</span>

          <h2>Ready to Build Something Exceptional?</h2>

          <p>
            Partner with Oglitz to transform your ideas into secure, scalable,
            and high-performance digital products trusted by global businesses.
          </p>

          <div className="srv-cta-actions">
            <a href="/contact" className="srv-cta-primary">
              Start a Project
            </a>

            <a
              href="https://wa.me/919532119007"
              className="srv-cta-whatsapp"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp Us
            </a>
          </div>

          <div className="srv-cta-trust">
            <span>India & UAE Presence</span>
            <span>Enterprise-Grade Security</span>
            <span>Transparent Pricing</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesTechnologies;
